var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "detail-layout"
    }
  }, [_c('viewer-container', {
    attrs: {
      "activeData": _vm.activeData,
      "focus": _vm.focus
    },
    on: {
      "pointedSelection": function($event) {
        _vm.executeOnPointedSelection()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "bottom": "0px",
      "width": "100%"
    },
    attrs: {
      "id": "tableWrapperContainer"
    }
  }, [_c('dynButton', {
    attrs: {
      "configs": {
        ID: 'buttons.table-resize',
        visible: true
      },
      "btnClasses": "table-resize-start",
      "icon": _vm.$root.icons.v_resize,
      "styleObj": {
        'border-width': '2px',
        //'border-top-right-radius': '35%', 
        //'border-top-left-radius': '35%',
        'border-style': 'solid',
        'border-color': '#999',
        'z-index': '999',
        'position': 'absolute',
        'top': '0px',
        'width': '28px',
        'height': '24px',
        'padding': '1.7px',
        'cursor': 'n-resize',
        'background-color': '#666',
        'color': 'white'
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-resize-stop resizable_table",
    staticStyle: {
      "overflow-y": "hidden",
      "overflow-x": "hidden"
    },
    attrs: {
      "id": "dtw-container"
    }
  }, [_c('dyn-table-wrapper', {
    attrs: {
      "arrayToTable": _vm.arrayToTable,
      "focus": _vm.focus,
      "name": "WrapperGrid"
    },
    on: {
      "API": _vm.assignAPI,
      "enabled": _vm.tableEnabled
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "fake_resizable_table",
    staticStyle: {
      "z-index": "-5",
      "background-color": "rgba(50, 62, 68, 0.13)",
      "position": "fixed",
      "width": "100%",
      "bottom": "0px"
    },
    attrs: {
      "id": "resize-shadow"
    }
  })], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f865a424","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sub-views/Detail.vue
// module id = 1654
// module chunks = 1